export const PERMISSION_PATH = [
    { permission: 'BI_SUITE_1', path: '/BI_1', urlKey: 'BI_1' },
    { permission: 'BI_SUITE_2', path: '/BI_2', urlKey: 'BI_2' },
    { permission: 'BI_SUITE_3', path: '/BI_3', urlKey: 'BI_3' },
    { permission: 'BI_SUITE_4', path: '/BI_4', urlKey: 'BI_4' },
    { permission: 'BI_SUITE_5', path: '/BI_5', urlKey: 'BI_5' },
    { permission: 'BI_SUITE_6', path: '/BI_6', urlKey: 'BI_6' },
    { permission: 'BI_SUITE_7', path: '/BI_7', urlKey: 'BI_7' },
    { permission: 'BI_SUITE_8', path: '/BI_8', urlKey: 'BI_8' },
    { permission: 'BI_SUITE_9', path: '/BI_9', urlKey: 'BI_9' },
    { permission: 'BI_SUITE_10', path: '/BI_10', urlKey: 'BI_10' },
];